import { Component, Input } from '@angular/core';
import { ReferenceDataLabels } from './../../../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from './../../../../../lib/constants/reference-data-option-lists';
import { ReferenceData } from './../../../../../lib/models/reference-data.model';
import { ReferenceDataService } from './../../../../../lib/services/reference-data.service';
import { ApplicationDepositSourceType } from './../../../models/application-deposit-source-type.model';
import { MortgageApplication } from './../../../models/mortgage-application.model';

@Component({
  selector: 'boi-form-deposit-source-type',
  templateUrl: './form-deposit-source-type.component.html',
  styleUrls: ['./form-deposit-source-type.component.scss']
})
export class FormDepositSourceTypeComponent {
  referenceDataLabels = ReferenceDataLabels;
  referenceDataOptionLists = ReferenceDataOptionLists;

  @Input() public mortgageApplication: MortgageApplication;
  public selectedDepositSourceTypeCode: string;

  constructor(private referenceDataService: ReferenceDataService) {}

  public removeDepositSourceType(depositSourceType: ApplicationDepositSourceType): void {
    if (
      this.mortgageApplication.ApplicationDepositSourceTypes &&
      this.mortgageApplication.ApplicationDepositSourceTypes.indexOf(depositSourceType) !== -1
    ) {
      this.mortgageApplication.ApplicationDepositSourceTypes.splice(
        this.mortgageApplication.ApplicationDepositSourceTypes.indexOf(depositSourceType),
        1
      );
    }
  }

  public getDepositSourceTypeLabel(depositSourceType: ApplicationDepositSourceType): string {
    const refData: ReferenceData = this.getDepositSourceRefData(depositSourceType);

    return refData ? refData.Value : undefined;
  }

  public areDetailsRequired(depositSourceType: ApplicationDepositSourceType): boolean {
    const refData: ReferenceData = this.getDepositSourceRefData(depositSourceType);

    return (
      refData.getAttributeValue(ReferenceDataOptionLists.DepositSourceTypeAreDetailsRequired.toLowerCase()) ===
      ReferenceDataOptionLists.AnswerTypeYes
    );
  }

  private getDepositSourceRefData(depositSourceType: ApplicationDepositSourceType): ReferenceData {
    return this.referenceDataService.getOptionListConfigItemByCode(
      ReferenceDataOptionLists.DepositSourceType,
      depositSourceType.DepositSourceTypeCode
    );
  }

  public addNewDepositSourceType(): void {
    if (!this.mortgageApplication.ApplicationDepositSourceTypes) {
      this.mortgageApplication.ApplicationDepositSourceTypes = [];
    }

    const depositSourceType = new ApplicationDepositSourceType();
    depositSourceType.ApplicationNumber = this.mortgageApplication.ApplicationNumber;
    depositSourceType.DepositSourceTypeCode = this.selectedDepositSourceTypeCode;

    this.mortgageApplication.ApplicationDepositSourceTypes.push(depositSourceType);
  }

  public canAddDepositSourceType(): boolean {
    let areFieldsCompleted: boolean;
    if (
      this.mortgageApplication.ApplicationDepositSourceTypes &&
      this.mortgageApplication.ApplicationDepositSourceTypes.length > 0
    ) {
      for (const depositSourceType of this.mortgageApplication.ApplicationDepositSourceTypes) {
        areFieldsCompleted = this.areDepositSourceTypeFieldsCompleted(depositSourceType);
      }
    } else {
      areFieldsCompleted = true;
    }

    return areFieldsCompleted;
  }

  private areDepositSourceTypeFieldsCompleted(depositSourceType: ApplicationDepositSourceType): boolean {
    const refData: ReferenceData = this.referenceDataService.getOptionListConfigItemByCode(
      ReferenceDataOptionLists.DepositSourceType,
      depositSourceType.DepositSourceTypeCode
    );

    let isDepositSourceCompleted = false;
    if (refData) {
      if (
        refData.getAttributeValue(ReferenceDataOptionLists.DepositSourceTypeAreDetailsRequired.toLowerCase()) ===
        ReferenceDataOptionLists.AnswerTypeYes
      ) {
        if (depositSourceType.DepositSourceTypeAmount && depositSourceType.DepositSourceTypeDetails) {
          isDepositSourceCompleted = true;
        }
      } else {
        if (depositSourceType.DepositSourceTypeAmount) {
          isDepositSourceCompleted = true;
        }
      }
    }

    return isDepositSourceCompleted;
  }
}
